var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: url(#linear-gradient1);\r\n      }\r\n\r\n      .st1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 85.1,
    y1: 159.9,
    x2: 85.1,
    y2: 10.3,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#049bb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086e94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 84.9,
    y1: 159.7,
    x2: 84.9,
    y2: 10.1,
    gradientTransform: "translate(0 170) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#049bb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086e94"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.8,69c-4.1-.2-8.1-.3-12-.3.3,10.9.3,21.8,0,32.7,4.1-.2,8.1-.2,12-.3-.3,7.8-.7,15.6-1.3,23.2-7.8.7-15.6,1.1-23.4,1.3.2-4.1.2-8,.3-12-10.9.3-22,.3-32.9,0,.2,4.1.2,8,.3,12-7.8-.3-15.6-.7-23.4-1.3-.7-7.8-1.1-15.6-1.3-23.2,4.1.2,8.1.3,12,.3-.3-10.9-.3-21.8,0-32.7-4.1.2-8.1.2-12,.3.3-7.8.7-15.6,1.3-23.4,7.8-.7,15.6-1.1,23.4-1.3-.2,4.1-.3,8.1-.3,12,10.9-.3,22-.3,32.9,0-.2-4.1-.2-8.1-.3-12,7.8.3,15.6.7,23.4,1.3.5,8,1,15.6,1.3,23.4ZM167.3,84.9c0,25.5-6,47-22.9,60.1-15.1,11.5-34.6,14.6-59.2,14.6s-44.2-3.1-59.4-15C8.7,131.7,2.9,110.4,2.9,84.8s5.9-47.1,22.9-60.1c15.1-11.5,34.6-14.5,59.2-14.5s44.2,3.1,59.4,14.5c16.9,13.3,22.9,34.9,22.9,60.3ZM152.7,86.4c0-48-20.8-68.1-67.5-68.1S17.3,34.2,17.3,83.3s20.8,68.4,67.5,68.4,67.8-16.1,67.8-65.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.8,12.4c27.7,0,45.1,4.2,58.1,14,15,11.5,22.1,30.7,22.1,58.5s-7.3,46.8-22.1,58.5c-13,9.9-30.4,14.3-57.9,14.3s-44.9-4.2-58.1-14.5c-15-11.2-22.1-30.4-22.1-58.2s7.2-47.1,22.1-58.5c13-10.1,29.9-14.1,57.9-14.1ZM84.8,154c24.9,0,41.6-4.7,52.7-14.8,11.7-10.7,17.2-27.5,17.2-52.7s-5.5-42.3-16.9-53.5c-11.2-11.4-28.5-16.9-52.7-16.9s-41.8,4.7-52.7,14.6c-11.7,10.6-17.1,27.3-17.1,52.5-.2,48.9,21.3,70.7,69.5,70.7ZM103.2,46.6c6.3.3,12.9.7,19.2,1.1.5,6.3.8,12.7,1.1,19.2-3.3-.2-6.5-.2-9.8-.3h-2.3v2.3c.3,10.9.3,21.8,0,32.7v2.3h2.3c3.3,0,6.5-.2,9.8-.3-.3,6.3-.7,12.8-1.1,19.2-6.3.5-12.7.8-19.2,1.1.2-3.3.2-6.5.3-9.8v-2.3h-2.3c-5.4.2-10.9.2-16.4.2s-10.9,0-16.4-.2h-2.3v2.3c0,3.3.2,6.5.3,9.8-6.3-.3-12.9-.7-19.2-1.1-.5-6.3-.8-12.7-1.1-19.2,3.3.2,6.5.2,9.8.3h2.3v-2.3c-.3-10.9-.3-21.8,0-32.7v-2.3h-2.3c-3.3,0-6.5.2-9.8.3.3-6.3.7-12.8,1.1-19.2,6.3-.5,12.9-.8,19.2-1.1-.2,3.3-.2,6.5-.3,9.8v2.3h2.3c5.4-.2,10.9-.2,16.4-.2s10.9,0,16.4.2h2.3v-2.3c0-3.3-.2-6.5-.3-9.8ZM84.8,10.3c-24.6,0-44.1,2.9-59.2,14.5C8.5,37.8,2.7,59.6,2.7,84.9s5.9,47,22.9,60c15.1,11.7,34.5,15,59.4,15s44.1-3.1,59.2-14.6c16.9-13.2,22.9-34.6,22.9-60.1s-6-47-22.9-60.1c-15-11.5-34.3-14.6-59.4-14.6ZM84.8,151.7c-46.7,0-67.5-20.5-67.5-68.4S38.6,18.3,85.2,18.3s67.5,20.2,67.5,68.1-21.6,65.3-67.8,65.3ZM101.1,44.3c.2,4.1.3,8.1.3,12-5.5-.2-10.9-.2-16.4-.2s-10.9,0-16.4.2c.2-4.1.2-8.1.3-12-7.8.3-15.6.7-23.4,1.3-.7,7.8-1.1,15.6-1.3,23.4,4.1-.2,8.1-.3,12-.3-.3,10.9-.3,21.8,0,32.7-4.1-.2-8.1-.2-12-.3.3,7.8.7,15.6,1.3,23.2,7.8.7,15.6,1.1,23.4,1.3-.2-4.1-.2-8-.3-12,5.5.2,10.9.2,16.4.2s10.9,0,16.4-.2c-.2,4.1-.2,8-.3,12,7.8-.3,15.6-.7,23.4-1.3.7-7.8,1.1-15.6,1.3-23.2-4.1.2-8.1.3-12,.3.3-10.9.3-21.8,0-32.7,4.1.2,8,.2,12,.3-.3-7.8-.7-15.6-1.3-23.4-8-.5-15.6-1-23.4-1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.017d2879b76e0bbd7f326f32d681edf5.svg";
export { ForwardRef as ReactComponent };